//
// RETURNS A FUNCTION THAT WHEN CALLED DOES THE NAVIGATION
//
const navigationActions = (navigate, location, rootPath) => ({
    landingPage: (item) => () => {
        if (item.isCourse()) {
            navigate(`${rootPath}/course/${item.slug || item.key}`);
        }
        else if (item.isProgram()) {
            navigate(`${rootPath}/program/${item.slug || item.key}`);
        }
        else if (item.isMicrocast()) {
            navigate(`${rootPath}/microcast/${item.slug || item.key}`);
        }
        else if (item.isMeeting()) {
            navigate(`${rootPath}/meeting/${item.slug || item.key}`);
        }
        else {
            console.log('item type not recognized', item);
        }
    },
    deliveryPage: (item) => () => {
        if (item.isCourse()) {
            navigate(`${rootPath}/class/${item.slug || item.key}`);
        }
        else if (item.isProgram()) {
            navigate(`${rootPath}/program/${item.slug || item.key}`);
        }
        else if (item.isMicrocast()) {
            navigate(`${rootPath}/microcast/${item.slug || item.key}`);
        }
        else if (item.isMeeting()) {
            navigate(`${rootPath}/meeting/${item.slug || item.key}`);
        }
        else {
            console.log('item type not recognized', item);
        }
    },
    categoryPage: (categoryId) => () => {
        navigate(`${rootPath}/cat/${categoryId}`);
    },
    membershipCheckout: (membershipID) => () => {
        navigate(`${rootPath}/checkout?type=membership&id=${membershipID}`, { state: { from: { location } } });
    },
    courseCheckout: (key) => () => {
        navigate(`${rootPath}/checkout?type=course&id=${key}`, { state: { from: { location } } });
    },
    programCheckout: (key) => () => {
        navigate(`${rootPath}/checkout?type=program&id=${key}`, { state: { from: { location } } });
    },
    membershipOfferPage: () => () => {
        navigate(`${rootPath}/memberships`);
    },
    instructorAction: (key) => {
        navigate(`${rootPath}/instructor/${key}`);
    },
    meetingAction: (key) => {
        navigate(`${rootPath}/meeting/${key}`);
    },
});
export default navigationActions;
//# sourceMappingURL=navigationActions.js.map